import { linkToDashboard, linkToJoinClass } from "features/dashboard/links";

export function linkToStudentClasses() {
  return `${linkToDashboard()}/classes`;
}

export function linkToStudentClassesPage() {
  return `${linkToStudentClasses()}/overview`;
}

export function linkToStudentAssignmentsPage() {
  return `${linkToStudentClasses()}/assignments`;
}

export function linkToStudentJoinClass() {
  return `${linkToStudentClassesPage()}${linkToJoinClass()}`;
}
